/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/15
 * Description: 文件描述
 */
import Vue from "vue";
import QS from "qs";
import axios from "axios";
// const errorHandler = (error, vm, info) => {
//   const API_ROOT = process.env.API_ROOT;
//   // const API_ROOT = process.env.API_ROOT.substring(8, 11)
//   const path = `路由:${vm.$route.path}`;
//   const message = `异常信息:${error.message}`;
//   const name = `异常名称:${error.name}`;
//   const script = `异常脚本url:${error.script}`;
//   const line = `异常行号:${error.line}`;
//   const column = `异常列号:${error.column}`;
//   const stack = `异常堆栈信息:${error.stack}`;
//   if (API_ROOT.indexOf("dev-erp") != -1) {
//     console.error(path);
//     console.error(message);
//     console.error(name);
//     console.error(script);
//     console.error(line);
//     console.error(column);
//     console.error(stack);
//   } else if (API_ROOT.indexOf("erp.service") != -1) {
//     console.error(error);
//   } else {
//     let machine = "";
//     switch (true) {
//       // case "dev":
//       //   console.error(message);
//       //   machine = "013";
//       //   break;
//       case API_ROOT.indexOf("stg-erp") != -1:
//         console.error(message);
//         machine = "00022";
//         break;

//       case API_ROOT.indexOf("pre-erp") != -1:
//         machine = "00022";
//         break;
//     }
//     const params = {
//       machine: machine,
//       owner: "姜友瑶(测试测试)",
//       errorMsg: error.stack,
//       projNo: machine,
//       exceptionType: name,
//       simpleMsg: error.message,
//       mdc: `登录人:${vm.$store.state.userInfo.mapInfo.userName} 账号:${vm.$store.state.userInfo.accountNumber} ${path} `
//     };
//     axios
//       .post("https://geek.xczhyf.cn/addException", QS.stringify(params), {
//         headers: {
//           "content-type": "application/x-www-form-urlencoded"
//           // token: store.state.token
//         }
//       })
//       .then(res => {})
//       .catch(err => {
//         console.error(err);
//       });
//   }
// };
// Vue.config.errorHandler = errorHandler;
// Vue.prototype.$throw = error => errorHandler(error, this);
Vue.directive("roleBtn", {
  bind: function(el, binding) {
    let roleArr = binding.value;
    let userRole = JSON.parse(sessionStorage.getItem("info")).role;
    if (roleArr && roleArr.indexOf(userRole) !== -1) {
      return false;
    } else {
      el.parentNode.removeChild(el);
    }
  }
});
export default Vue;



// WEBPACK FOOTER //
// ./src/btnPermission.js